import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  threads: [],
  messages: [],
  currentThread: null,
  isLoading: false,
  isError: false,
  message: '',
  filters: {
    counterparty: '',
    accountType: '',
    messageType: '',
    dateRange: null,
    threadType: '',
    hasAttachments: false,
  },
};

export const messageSlice = createSlice({
  name: 'messages',
  initialState,
  reducers: {
    reset: (state) => {
      state.isLoading = false;
      state.isError = false;
      state.message = '';
    },
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    setCurrentThread: (state, action) => {
      state.currentThread = action.payload;
    },
  },
});

export const { reset, setFilters, setCurrentThread } = messageSlice.actions;
export default messageSlice.reducer;